import { type FormSubmission, type FormSubmissionFieldValues } from "@overmap-ai/common"
import { FormSubmissionFieldValuesAttachmentService as OvermapFormSubmissionFieldValuesAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormSubmissionFieldValuesAttachmentService extends OvermapFormSubmissionFieldValuesAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL

	bulkAddForFormSubmissionFieldValues(
		formSubmissionFieldValuesId: FormSubmissionFieldValues["uuid"],
		files: Record<string, File[]>,
	) {
		return this.bulkAdd(
			Object.entries(files)
				.map(([fieldId, files]) =>
					files.map((file) => ({
						field_values: formSubmissionFieldValuesId,
						file: file,
						field_identifier: fieldId,
					})),
				)
				.flat(),
		)
	}

	async refreshStoreForFormSubmission(formSubmissionId: FormSubmission["uuid"], signal?: AbortSignal) {
		const { addMany } = this.actions

		const result = await this.listPaginated(
			{
				queryParams: {
					field_values__form_submission: formSubmissionId,
				},
			},
			signal,
		)

		const flattened = result.flat()
		this.dispatch(addMany(flattened))
		return flattened
	}
}
